import React, { useEffect } from 'react';
import { CheckCircle, XCircle, X } from 'lucide-react';

const Toast = ({ message, type = 'success', onClose, duration = 3000 }) => {
  useEffect(() => {
    if (duration) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [onClose, duration]);

  const isSuccess = type === 'success';

  return (
    <div className="fixed bottom-6 right-6 z-[10000] animate-[slideInRight_0.3s_ease-out]">
      <div className={`flex items-center gap-3 px-5 py-4 rounded-2xl shadow-2xl border ${
        isSuccess 
          ? 'bg-white border-green-100 text-green-800' 
          : 'bg-white border-red-100 text-red-800'
      }`}>
        <div className={`p-2 rounded-full ${isSuccess ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}>
          {isSuccess ? <CheckCircle size={20} /> : <XCircle size={20} />}
        </div>
        <p className="font-bold text-sm pr-4">{message}</p>
        <button 
          onClick={onClose}
          className="p-1 hover:bg-gray-100 rounded-lg text-gray-400 transition-colors"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default Toast;
